import { Injectable } from '@angular/core';
import {
  IssueVerifiedCredentialInput,
  IssueVerifiedCredentialMutation,
  LoadVerifiedCredentialIssuersQuery,
  RequestVerifiedCredentialPresentationInput,
  RequestVerifiedCredentialPresentationMutation,
  UpdateVerifiedCredentialIssuerInput,
  UpdateVerifiedCredentialIssuerMutation
} from '@queries/generated';
import { finalMap } from '@rx/final-map';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VerifiedCredentialsService {
  constructor(
    private issueVerifiedCredentialMutation: IssueVerifiedCredentialMutation,
    private loadVerifiedCredentialIssuersQuery: LoadVerifiedCredentialIssuersQuery,
    private requestVerifiedCredentialPresentationMutation: RequestVerifiedCredentialPresentationMutation,
    private updateVerifiedCredentialIssuerMutation: UpdateVerifiedCredentialIssuerMutation
  ) {}

  issue(input: IssueVerifiedCredentialInput) {
    return this.issueVerifiedCredentialMutation.mutate({ input }).pipe(map(({ data }) => data.issueVerifiedCredential));
  }

  issuers = (id: number) => {
    return this.loadVerifiedCredentialIssuersQuery
      .fetch({ id })
      .pipe(map(({ data }) => data.organizations.findById.verifiedCredentialIssuers));
  };

  requestPresentation(input: RequestVerifiedCredentialPresentationInput) {
    return this.requestVerifiedCredentialPresentationMutation
      .mutate({ input })
      .pipe(map(({ data }) => data.requestVerifiedCredentialPresentation));
  }

  update(input: UpdateVerifiedCredentialIssuerInput) {
    return this.updateVerifiedCredentialIssuerMutation.mutate({ input }).pipe(
      map(({ data }) => data.updateVerifiedCredentialIssuer),
      finalMap('verifiedCredentialIssuer')
    );
  }
}
